import { getElement } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

const SCROLL_OFFSET = 360

class TopButton {
  private readonly button: HTMLElement | null = null

  constructor () {
    this.button = getElement('top-button')
  }

  public init (): void {
    if (this.button === null) return

    this.addEvents()
  }

  private addEvents (): void {
    window.addEventListener('scroll', (): void => this.toggle(), { passive: true })
  }

  private toggle (): void {
    if (window.scrollY > SCROLL_OFFSET) {
      this.button?.classList.add(IS_ACTIVE)
    } else {
      this.button?.classList.remove(IS_ACTIVE)
    }
  }
}

const topButton = new TopButton()
topButton.init()
